module.exports = __webpack_public_path__ + "files/7085ee62f79d58a3d0983079a249c737.png";